/**
 * import and init global mixins
 */

import Vue from 'vue'

import jumpTo from './jumpTo'
import formatDateTime from './formatDateTime'
 
Vue.mixin(jumpTo)
Vue.mixin(formatDateTime)
